import React from "react";

import { Check } from "lucide-react";

export default function StatusStepper({ currentStage, stages }) {
  const curIdx = stages.findIndex((s) => s.key === currentStage);
  return (
    <div className="w-full overflow-x-auto">
      <div className="flex items-start justify-between min-w-[640px] gap-2 py-3">
        {stages.map((s, idx) => {
          const Icon = s.icon;
          const active = idx === curIdx;
          const done = idx < curIdx;
          return (
            <div key={s.key} className="flex-1 flex flex-col items-center relative"
                 data-testid={`stepper-stage-${s.key}`}>
              {idx > 0 && (
                <div className={`absolute top-5 right-1/2 w-full h-[2px] ${done || active ? "bg-blue-500/70" : "bg-slate-700"}`} />
              )}
              <div
                className={`relative z-10 w-10 h-10 rounded-full flex items-center justify-center border-2
                ${active ? "bg-blue-600 border-blue-300 stepper-dot-active" :
                  done ? "bg-emerald-600/80 border-emerald-400" :
                  "bg-slate-800 border-slate-700"}`}
              >
                {done ? <Check size={16} /> : <Icon size={16} />}
              </div>
              <div className={`mt-2 text-[11px] uppercase tracking-widest text-center ${
                active ? "text-sky-300" : done ? "text-emerald-300" : "text-slate-500"
              }`}>
                {s.label}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
